import "./SeatSelection.css";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Loading from "../../components/spinner/Loading";
import moment from "moment";
import { FaRegEdit } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import SeatSelectionSlide from "./SeatSelectionSlide";
import {
  DUMMY_SEAT_MAP_RESPONSE,
  DUMMY_SSR_RESPONSE,
} from "../../_constants/constant";
import { settabIndex } from "./reviewbookingSlice";
import MealSelection from "./MealSelection";
import BaggageSelection from "./BaggageSelection";
import WheelChairSelection from "./WheelChairSelection";

const AddonSelection = ({
  travellers,
  alltravellers,
  // setTravellerConfirm,
  // setProcessContinue,
  toggleTotalSeatSelection,
  toggleMealSelection,
  toggleBaggageSelection,
  toggleWheelChairSelection,
  totalSeats,
  selectedmealPerSegment,
  selectedBaggagePerSegment,
  selectedWheelChairPerSegment,
}: {
  travellers: any[];
  alltravellers: any[];
  selectedmealPerSegment: {
    [index: number]: any[];
  };
  selectedBaggagePerSegment: {
    [index: number]: any[];
  };
  selectedWheelChairPerSegment: {
    [index: number]: any[];
  };
  // setTravellerConfirm: (confirm: boolean) => void;
  // setProcessContinue: (confirm: boolean) => void;
  toggleTotalSeatSelection: (seat: any, index: number) => void;
  toggleMealSelection: (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => void;
  toggleBaggageSelection: (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => void;
  toggleWheelChairSelection: (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => void;
  totalSeats: any[];
}) => {
  const dispatch = useAppDispatch();
  const flightReviewDetails = useAppSelector(
    (state) => state.reviewbooking.flightReviewDetails
  );
  const seatmapData = useAppSelector(
    (state) => state.reviewbooking.seatmapData
  );
  const ssrData = useAppSelector((state) => state.reviewbooking.ssrData);
  const tabIndex = useAppSelector((state) => state.reviewbooking.tabIndex);

  const loading = useAppSelector((state) => state.reviewbooking.loading);

  const routewiseSegmentArray = flightReviewDetails.flatMap(
    (e: any) => e.Flight?.Segments
  );

  return (
    <>
      <Loading loading={loading} backgroundColor="white" />
      {flightReviewDetails?.length > 0 && (
        <>
          <div className="information-card seat-selection-main-card">
            <div className="p-6 max-w-3xl mx-auto">
              <div className="seat-slection-title">
                <h4 className="m-0">
                  {ssrData?.length > 0 && (
                    <>
                      <span
                        className={`title-name ${
                          tabIndex === 2 ? "active" : ""
                        }`}
                        onClick={() => dispatch(settabIndex(2))}
                      >
                        Meals
                      </span>
                      <span
                        className={`title-name ${
                          tabIndex === 3 ? "active" : ""
                        }`}
                        onClick={() => dispatch(settabIndex(3))}
                      >
                        Baggage
                      </span>
                    </>
                  )}
                  {seatmapData?.length > 0 && (
                    <span
                      className={`title-name ${tabIndex === 1 ? "active" : ""}`}
                      onClick={() => dispatch(settabIndex(1))}
                    >
                      Seats
                    </span>
                  )}
                  {ssrData?.length > 0 && (
                    <span
                      className={`title-name ${tabIndex === 4 ? "active" : ""}`}
                      onClick={() => dispatch(settabIndex(4))}
                    >
                      Wheel Chair
                    </span>
                  )}
                </h4>
              </div>
              <div>
                {tabIndex === 1 && (
                  <Swiper
                    slidesPerView={"auto"}
                    spaceBetween={30}
                    pagination={{
                      clickable: true,
                    }}
                    navigation={true}
                    modules={[Navigation]}
                    allowTouchMove={false}
                    className="ssr-slider"
                  >
                    {seatmapData &&
                      seatmapData
                        .flatMap((route: any) => route.Seat_Segments || [])
                        .map((seat_row: any, index: number) => {
                          const totalSegment = seatmapData.flatMap(
                            (route: any) => route.Seat_Segments || []
                          ).length;

                          return (
                            <SwiperSlide
                              key={index}
                              className={`${
                                totalSegment === 1 ? "one-slide" : "multi-slide"
                              }`}
                            >
                              <SeatSelectionSlide
                                toggleTotalSeatSelection={
                                  toggleTotalSeatSelection
                                }
                                seat_row={seat_row}
                                index={index}
                                OriginCity={
                                  routewiseSegmentArray[index]?.Origin_City
                                }
                                DestinationCity={
                                  routewiseSegmentArray[index]?.Destination_City
                                }
                                travellers={travellers}
                                selectedSeats={totalSeats?.filter((e: any) => {
                                  return (
                                    e?.segmentindex === index &&
                                    e?.segmentPlace ===
                                      `${routewiseSegmentArray[index]?.Origin_City}-${routewiseSegmentArray[index]?.Destination_City}`
                                  );
                                })}
                              />
                            </SwiperSlide>
                          );
                        })}
                  </Swiper>
                )}
                {tabIndex === 2 && (
                  <MealSelection
                    toggleMealSelection={toggleMealSelection}
                    flightReviewDetails={flightReviewDetails}
                    travellers={travellers}
                    selectedmealPerSegment={selectedmealPerSegment}
                  />
                )}
                {tabIndex === 3 && (
                  <BaggageSelection
                    toggleBaggageSelection={toggleBaggageSelection}
                    flightReviewDetails={flightReviewDetails}
                    travellers={travellers}
                    selectedBaggagePerSegment={selectedBaggagePerSegment}
                  />
                )}
                {tabIndex === 4 && (
                  <WheelChairSelection
                    toggleWheelChairSelection={toggleWheelChairSelection}
                    flightReviewDetails={flightReviewDetails}
                    travellers={travellers}
                    selectedWheelChairPerSegment={selectedWheelChairPerSegment}
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AddonSelection;
